import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconShow$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconShow extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd3b94881b171a28a2d5846808c72baa2317effac', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '342cdbb3a34dba1ce11bc1431a12a04159d76792', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '39cdb33822d384d78de717c1d8bb7e00d8f085d1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 8.218h-5.36l2.43-3a.5.5 0 0 0-.08-.7l-.39-.3a.49.49 0 0 0-.7.08l-3.17 3.92-5.05-5.07a.5.5 0 0 0-.71 0l-.35.35a.5.5 0 0 0 0 .71l4 4H3.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-9.99a.5.5 0 0 0-.5-.5m-1 1.5v8h-13v-8zm-5.61 3.02 1.7.15c.27.03.34.18.11.33l-1.38 1.17.49 1.63c.07.2-.05.35-.27.2l-1.54-1-1.45.99c-.27.15-.35.05-.27-.2l.49-1.64-1.36-1.14c-.21-.17-.17-.35.1-.35l1.73-.16.59-1.59c.1-.25.26-.25.37 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-show", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-show"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-show":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconShow$1);
            }
            break;
    } });
}

const CosmosIconShow = CosmosIconShow$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconShow, defineCustomElement };
